import { apiService } from './api.service';
import { ApiResponse, Ticket, TicketFields } from '../types';

export const uploadService = {
  uploadTicket(
    file: File,
    ticketData: {
      type: string;
      description?: string;
      location?: string;
      dateIssued?: string;
    }
  ): Promise<ApiResponse<Ticket>> {
    return apiService.uploadTicket(file, ticketData);
  },

  startTicketExtraction(
    file: File
  ): Promise<ApiResponse<{ ticketId: string; appealSessionId?: string; fields: TicketFields; ticket?: Ticket }>> {
    return apiService.startTicketExtraction(file);
  },

  uploadEvidence(ticketId: string, files: File[]): Promise<ApiResponse<string[]>> {
    return apiService.uploadEvidence(ticketId, files);
  },
};

export default uploadService;
